/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetUsersPreferencesWaterCharacteristicsStatus200, GetUsersPreferencesWaterCharacteristicsStatus204, GetUsersPreferencesWaterCharacteristicsStatus401 } from '../types/GetUsersPreferencesWaterCharacteristics'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsersPreferencesWaterCharacteristics } from '../clients/getUsersPreferencesWaterCharacteristics'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersPreferencesWaterCharacteristicsQueryKey = () => [{ url: '/users/preferences/water-characteristics/' }] as const

type GetUsersPreferencesWaterCharacteristicsQueryKey = ReturnType<typeof getUsersPreferencesWaterCharacteristicsQueryKey>

export function getUsersPreferencesWaterCharacteristicsQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getUsersPreferencesWaterCharacteristicsQueryKey()
  return queryOptions<GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, ResponseErrorConfig<GetUsersPreferencesWaterCharacteristicsStatus401>, GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getUsersPreferencesWaterCharacteristics({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /users/preferences/water-characteristics/}
 */
export function useGetUsersPreferencesWaterCharacteristics<TData = GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, TQueryData = GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, TQueryKey extends QueryKey = GetUsersPreferencesWaterCharacteristicsQueryKey>(options: {
  query?: Partial<QueryObserverOptions<GetUsersPreferencesWaterCharacteristicsStatus200 | GetUsersPreferencesWaterCharacteristicsStatus204, ResponseErrorConfig<GetUsersPreferencesWaterCharacteristicsStatus401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getUsersPreferencesWaterCharacteristicsQueryKey()

  const queryResult = useQuery({
   ...getUsersPreferencesWaterCharacteristicsQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersPreferencesWaterCharacteristicsStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
